const initialState = {
  loadingCreditSettings: true,
}

const setupSettings = (state, { payload }) => {
  return { ...state, ...payload }
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'PROMISED_PAYMENT/SETUP_SETTINGS':
      return setupSettings(state, action)
    default:
      return state
  }
}

export default reducer
